/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Calm_Crane_StandInputs */

const en_tall_calm_crane_stand = /** @type {(inputs: Tall_Calm_Crane_StandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Height`)
};

const de_tall_calm_crane_stand = /** @type {(inputs: Tall_Calm_Crane_StandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höhe`)
};

/**
* | output |
* | --- |
* | "Height" |
*
* @param {Tall_Calm_Crane_StandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_calm_crane_stand = /** @type {((inputs?: Tall_Calm_Crane_StandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Calm_Crane_StandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_calm_crane_stand(inputs)
	return de_tall_calm_crane_stand(inputs)
});